<div>
  <app-table-component
    [cols]="cols"
    [data]="kioskData()"
    [loading]="tableLoading()"
    [totalRecords]="sessionServiceRespone()?.totalElements"
    [searchable]="true"
    searchInputPlaceholder="Search Kiosk"
    (onChangePage)="onChangePage()"
    (searchFilter)="onSearchFilter($event)"
  />

  <!-- Templates -->
  <ng-template #statusColumnTemplate let-rowData="rowData">
    <div [class]="rowData.status === 'red' ? 'status-indicator error' : 'status-indicator'">
      <div [class]="rowData.status === 'red' ? 'status-dot error' : 'status-dot'"></div>
    </div>
  </ng-template>

  <ng-template #nameColumnTemplate let-rowData="rowData">
    <span>{{ rowData.computerName }}</span>
    <span class="pl-2" *ngIf="rowData.isFirstTime">
      <i
        class="pi pi-question-circle !text-sm"
        pTooltip="No activity has been detected for the past {{ noActivityDays }} days."
      ></i>
    </span>
  </ng-template>

  <ng-template #detailColumnTemplate let-rowData="rowData">
    <p-button outlined variant="text" severity="info" (onClick)="openDetailDialog(rowData)">
      Show Detail
    </p-button>
  </ng-template>

  <!-- Dialogs -->
  <app-kiosk-detail />
</div>
